// Back and Forward can show a page exactly as it was left (the back/forward cache), so after logging out, Back could
// show the account's pages again: logging out clears the browser's cache (Clear-Site-Data), but Chrome keeps these
// pages anyway. Likewise, a page kept from before logging in would still say "Log in", with a form token that no
// longer works.
//
// So each page names the session it was made for (<meta name="session-marker">, before this script in the <head>: a
// random value while logged in, blank for guests; see ApplicationController#session_marker), and notes it in a cookie
// as soon as it starts loading. A page shown again from the back/forward cache whose session isn't the latest one
// hides itself and reloads, so the server sends what's current. A cookie rather than localStorage: a page coming back
// from the cache can read an out-of-date localStorage, but always sees the current cookies. It's only there while
// logged in, and logging out removes it too (ApplicationController#clear_browser_cache).
//
// Back and Forward can also load a page from the browser's HTTP cache, a copy that may be from another session too
// (browsers that ignore Clear-Site-Data still have the account's pages after logging out). Such a copy mustn't note
// its marker. If it's a logged-in page from another session, it reloads like the ones above; a guest page (while
// logged in) is left as it is, since it may be the result of a form (e.g. a failed log-in), which reloading would send
// again.
//
// A session ended elsewhere (a password change on another device, say) leaves this browser's cookie as it was, so its
// Back can still show pages it showed while that session lasted. The owner accepted that (2026-10-24) rather than ask
// the server on every Back.

var meta = document.querySelector('meta[name="session-marker"]');

function latestMarker() {
  var match = document.cookie.match(/(?:^|;\s*)session_marker=([^;]*)/);
  return match ? match[1] : '';
}

function noteMarker(marker) {
  var secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = 'session_marker=' + marker + '; path=/; SameSite=Lax' + secure + (marker ? '' : '; max-age=0');
}

if (meta) { // pages with the site's layout
  var marker = meta.getAttribute('content');
  var navigation = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var fromHistory = navigation && navigation.type === 'back_forward';

  if (latestMarker() !== marker) {
    if (!fromHistory) {
      noteMarker(marker);
    } else if (marker) {
      // Still in the <head>, so nothing of the page has been shown yet
      document.documentElement.style.visibility = 'hidden';
      location.reload();
    }
  }

  window.addEventListener('pageshow', function(e) {
    if (e.persisted && latestMarker() !== marker) {
      // Hidden first, so the reload doesn't keep showing this page until the new one arrives
      document.documentElement.style.visibility = 'hidden';
      requestAnimationFrame(function() { setTimeout(function() { location.reload(); }, 0); });
    }
  });
}
